import React, { useEffect, useState } from "react";
import CardCarousel from "../../component/global/cardCarousel";
import ViewConfig from "../../config/viewConfig";
import SearchFooter from "../../component/content/searchJobFooter";
import '../../index.css'
import CircleEffect from "../../component/global/circleEffect";
import { useDispatch, useSelector } from "react-redux";
import Lang from "../../config/lang";
import { isStageUrl } from "../../config/helper";
import { useParams } from "react-router-dom";
import { setLanguage } from "../../redux/actions/language";

const Teams = ({ }) => {
    const mobileView = ViewConfig();
    const [currentSlide, setCurrentSlide] = useState(0);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const { lang } = useSelector((state) => state.globalReducer);

    const dispatch = useDispatch();
    const { language } = useParams();

    useEffect(() => {
        if (language) {
            dispatch(setLanguage(language));
        }
    }, [language])


    const arrTestimony = [
        { image: '/asset/person1.png' },
        { image: '/asset/person2.png' },
        { image: '/asset/person3.png' },
        { image: '/asset/person1.png' },
        { image: '/asset/person2.png' },
        { image: '/asset/person3.png' },
    ];

    const coreValues = [
        { title: Lang(lang, 'sustainability'), desc: Lang(lang, 'core_value_desc1'), bgImg: 'linear-gradient(145deg, #FFFFFF 10%, #ffffff29 111%)', boxShadow: '1px 7px 17px rgba(0 118 255 / 7%)', icon: '/asset/sustainability.svg' },
        { title: Lang(lang, 'innovation'), desc: Lang(lang, 'core_value_desc2'), bgImg: 'linear-gradient(145deg, #1067cb 15%, #F1F5F9 110%)', boxShadow: '1px 7px 17px rgba(0 118 255 / 7%)', icon: "/asset/innovation.svg" },
        { title: Lang(lang, 'transparency'), desc: Lang(lang, 'core_value_desc3'), bgImg: 'linear-gradient(145deg, #EA2427 40%, #939393 100%, #48494B 100%)', boxShadow: '1px 7px 17px rgba(0 118 255 / 7%)', icon: "/asset/transparency.svg" },
        { title: Lang(lang, 'efficiency'), desc: Lang(lang, 'core_value_desc4'), bgImg: "linear-gradient(145deg, #898A8B 35%, #FFFFFF 110%)", boxShadow: '1px 7px 17px rgba(0 118 255 / 7%)', icon: '/asset/efficiency.svg' },
        { title: Lang(lang, 'collaboration'), desc: Lang(lang, 'core_value_desc5'), bgImg: "linear-gradient(145deg, #BBE6FF 1%, #FFFFFF 110%)", boxShadow: '1px 7px 17px rgba(0 118 255 / 7%)', icon: '/asset/collaboration.svg' },
    ];
    const people = [
        { name: "Andreas", title: "", email: "", img: "/asset/PakAndreas.webp" },
        { name: "Sylvia", title: "", email: "", img: "/asset/BuSylvi.webp" },
        { name: "Kastria", title: "", email: "", img: "/asset/BuKastria.webp" },
        { name: "Achmed", title: "", email: "", img: "/asset/PakAchmed.webp" },
        { name: "Hendrawan", title: "", email: "", img: "/asset/PakHendrawan.webp" },
        { name: "Halim", title: "", email: "", img: "/asset/PakHalim.webp" },
    ];

    return (<>
        <div className="pt-8">
            <p className='text-[#48494B] text-[32px] md:text-[84px] w-[80%] md:w-full mx-auto font-normal leading-tight text-center'>
                {Lang(lang, 'why_join')} <CircleEffect
                    setClass={'text-[#EA2427] font-semibold'}
                    setClassDoodle={'-bottom-16 md:-bottom-15 h-[145px] md:h-[140px] w-full left-[-2px] md:left-[-1px]'}
                    text={'SOPRA?'}
                    setColor="#034694"
                    type="line"
                />
            </p>
        </div>

        <div className="pt-8 flex flex-col mx-auto gap-6 w-[80%] md:w-[72%] max-w-[1180px]">
            <div className={`rounded-[20px] md:rounded-[30px] flex min-h-0 md:min-h-[400px] bg-white flex-col md:flex-row`} style={{ boxShadow: '1px 0px 6px 0px rgb(0 118 255 / 7%)' }}>
                <div className={`rounded-ss-[20px] md:rounded-ss-[30px] rounded-se-[20px] md:rounded-se-[0px] md:rounded-es-[30px] md:rounded-ee-0 bg-slate-600 w-full md:w-[45%] h-[200px] md:h-auto`} style={{ backgroundImage: `url('/asset/JoinSopra.webp')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} />
                <div className="flex flex-col justify-center gap-2 md:gap-4 py-4 md:py-6 m-auto w-[85%] md:w-[40%]">
                    <p className="text-[20px] md:text-[30px] font-bold text-[#034694]">{Lang(lang, 'why_join_content_title')}</p>
                    <p className="font-normal md:font-medium text-sm md:text-xl">{Lang(lang, 'why_join_content_desc')}</p>
                </div>
            </div>
        </div>

        <div className="py-20 md:py-28 mt-20" style={{ backgroundImage: 'linear-gradient(160deg, #7BB3F466 5%, #F1F5F9 20%, #7BB3F466 100%)' }}>
            <p className='text-[#48494B] text-[32px] md:text-[84px] font-normal leading-tight text-center'>
                {lang === 'en' ? 'Our' : 'Nilai'} <CircleEffect
                    setClass={'text-[#034694] font-semibold'}
                    setClassDoodle={lang === 'en' ? '-bottom-14 md:-bottom-1 h-[145px] md:h-[140px] w-[90px] md:w-[240px] left-[-2px] md:left-[-6px]' : '-bottom-14 md:-bottom-6 h-[145px] md:h-[185px] w-[90px] md:w-[335px] left-[-2px] md:left-[-6px]'}
                    text={lang === 'en' ? 'core' : 'utama'}
                /> {lang === 'en' ? 'values' : 'kami'}
            </p>

            <div class='flex flex-col md:flex-row justify-center items-center gap-6 mt-8 md:mt-[54px] md:mt-16 text-[#000000] text-center w-[80%] mx-auto max-w-[1180px]' data-aos="fade-left">
                <CardCarousel
                    data={coreValues}
                    setHeight={mobileView ? '270px' : '450px'}
                    mobileView={mobileView}
                    isFlat={true}
                    renderCard={(item, index, isActive) => (
                        <div class={'relative flex flex-col justify-center rounded-[20px] md:rounded-[35px] p-3 md:p-2 text-sm font-normal w-[233px] lg:w-[280px] xl:w-[340px] 2xl:w-[383px] h-[233px] lg:h-[280px] xl:h-[340px] 2xl:h-[377px] bg-white text-center'} style={{ backgroundImage: item.bgImg, boxShadow: item.boxShadow }}>
                            <div class='absolute top-4 left-5'><img class='w-[65%]' src={item.icon} /></div>
                            <h3 class={(index === 0 || index === 4) ? 'text-xl md:text-3xl font-medium text-[#48494B]' : 'text-xl md:text-3xl font-medium text-white'}>{item.title}</h3>
                            <p class={(index === 0 || index === 4) ? 'pt-6 text-xs md:text-sm w-[80%] mx-auto text-center text-[#48494B]' : 'pt-6 text-xs md:text-sm w-[80%] mx-auto text-center text-white'}>{item.desc}</p>
                        </div>
                    )}
                    onSlideChange={(index) => setCurrentSlide(index)}
                    autoPlay={false}
                />
            </div>
            <div className="justify-center items-center mx-auto w-[80%] md:w-[72%] max-w-[1180px] mt-[60px] md:mt-[143px]">
                <img src="/asset/empowering_communities.png" className="w-[100%]" />
            </div>
        </div>

        <div className="pt-16 md:pt-28">
            <p className='text-[#48494B] text-[32px] md:text-[84px] font-normal leading-tight text-center'>
                Meet the <CircleEffect
                    setClass={'text-[#EA2427] font-semibold'}
                    setClassDoodle={'-bottom-14 md:-bottom-8 h-[145px] md:h-[220px] w-[90px] md:w-[375px] left-[-2px] md:left-[-2px]'}
                    text={'S-team'}
                    setColor="#034694" />
            </p>
            <div class="mt-20 gap-4 py-8 md:py-10 h-[200px] md:h-[70vh] bg-center" style={{ backgroundImage: `url('/asset/S-Team.webp')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}></div>


            {/* <div className="list-container w-full">
                {people.map((person, index) => (
                    <div
                        key={index}
                        className={`list-item ${hoveredIndex === index ? "active" : ""} h-[60px] md:h-[131px] w-full bg-[#E4F0FF] border-b border-[#034694] py-4 md:py-8 px-8 md:px-10 2xl:px-24 flex flex-row justify-between items-center`}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div className="text-sm md:text-[32px] font-medium" style={{ flex: 3 }}>{person.name}</div>
                        <div className="" style={{ flex: mobileView ? 3 : 1.4 }}>
                            <div className="text-xs md:text-[22px] font-medium">{person.title}</div>
                            <div className="text-[10px] md:text-[16px] md:mt-2">{person.email}</div>
                        </div>
                        {!mobileView && <div style={{ flex: 2 }}>
                            <div className={`img-wrapper ${hoveredIndex === index ? "fade-in" : "fade-out"} mr-10 w-[120px] h-[120px] md:w-[260px] md:h-[260px]`}>
                                <img src={person.img} alt={person.name} className="profile-img" />
                            </div>
                        </div>}
                        <div className="items-end justify-end"  >
                            <span className="linkedin text-[20px] md:text-[30px]">in</span>
                        </div>
                    </div>
                ))}
            </div> */}
        </div>

        {/* {isStageUrl() &&
            <div className="pt-16 md:pt-28 mb-24">
                <p className='text-[#48494B] text-[32px] md:text-[72px] font-normal leading-tight text-center'><b className='text-[#034694] font-semibold'>Hear</b> it from the <b className='text-[#EA2427] font-semibold'>team</b> </p>
                <div className="mt-12 md:mb-12 p-6 md:p-8 bg-white w-[80%] max-w-[1180px] mx-auto rounded-[35px]" style={{ boxShadow: '1px 0px 6px 0px rgb(0 118 255 / 7%)' }}>
                    <CardCarousel
                        data={arrTestimony}
                        setHeight={mobileView ? '400px' : '620px'}
                        mobileView={mobileView}
                        renderCard={(item, index, isActive) => (
                            <div className="flex flex-col flex-shrink-0 bg-[#E4F0FF] p-2 rounded-[35px] w-[270px] md:w-[300px]" style={{ boxShadow: '1px 0px 6px 0px rgb(0 118 255 / 7%)' }}>
                                <div className="bg-slate-600 rounded-[35px] h-[350px] md:h-[500px] w-full relative" style={{ backgroundImage: `url(${item?.image})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                                    <div className='absolute top-4 left-5'><img className='w-[65%]' src="/asset/play.png" /></div>
                                    <div className='absolute bottom-4 right-2'><img className='w-[65%]' src="/asset/sound.png" /></div>
                                </div>
                            </div>
                        )}
                        onSlideChange={(index) => setCurrentSlide(index)}
                        autoPlay={false}
                    />
                </div>
            </div>
        } */}

        <SearchFooter />
    </>);
}

export default Teams;